<template>
  <div class="font-size-h3 text-default text-center">
    <span>
      Thank you for adding your card details. Your appointment on
    </span>
    <span class="font-weight-bold">
      {{formattedStartDay}}, {{formattedStartDate}} at {{formattedStartTime}}
    </span>
    <span>
      has been confirmed. An email confirmation will be sent to you shortly. We look forward to seeing you!
    </span>
  </div>
</template>

<script>
import { BookingPaymentDateTimeMixin } from '@/mixins/BookingPayment/BookingPaymentDateTimeMixin'

export default {
  name: 'DisplayedOutstanding',
  mixins: [BookingPaymentDateTimeMixin]
}
</script>
